import * as fs from 'fs';
import { Injectable } from '@gitlab-org/di';
import { EmptyFsClient, FsClient } from '../../../common/services/fs/fs';

@Injectable(FsClient, [])
export class DesktopFsClient extends EmptyFsClient {
  promises: FsClient['promises'] = {
    readFile: fs.promises.readFile.bind(fs),
    writeFile: fs.promises.writeFile.bind(fs),
    unlink: fs.promises.unlink.bind(fs),
    readdir: fs.promises.readdir.bind(fs),
    mkdir: fs.promises.mkdir.bind(fs),
    rmdir: fs.promises.rmdir.bind(fs),
    stat: fs.promises.stat.bind(fs),
    lstat: fs.promises.lstat.bind(fs),
    chmod: fs.promises.chmod.bind(fs),
    readlink: fs.promises.readlink.bind(fs),
    symlink: fs.promises.symlink.bind(fs),
  };
}
